import { Box, Card, CardContent, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

// Windster 風 stat card: icon + value + label
export default function BusinessStatCard({ icon, title, value, accent = 'primary' }) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, '&:last-child': { pb: 2 } }}>
        {icon && (
          <Box
            sx={(theme) => ({
              width: 48,
              height: 48,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: alpha(theme.palette[accent].main, 0.1),
              color: theme.palette[accent].main,
              flexShrink: 0,
              '& svg': { fontSize: 24 },
            })}
          >
            {icon}
          </Box>
        )}
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
            {value}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {title}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
